var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirdeskIconSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.999,
    height: 28.26,
    viewBox: "0 0 24.999 28.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21077.001 4064)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M461.333,218.47a.751.751,0,0,0-.742-.47h-4.533a.653.653,0,0,0-.663.47l-4.8,13.144a.6.6,0,0,0,.451.784c1.511.235,3.022.392,4.586.5a.574.574,0,0,0,.583-.392l2.174-6.533,2.174,6.533a.558.558,0,0,0,.61.392,42.914,42.914,0,0,0,4.533-.5.571.571,0,0,0,.451-.784Z",
    transform: "translate(-21522.863 -4282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M457.587,279.483a.572.572,0,0,0-.738-.549,47.165,47.165,0,0,1-23.519,0,.584.584,0,0,0-.738.549v3.946a.613.613,0,0,0,.448.575c.5.1,1,.235,1.5.34l-1.9,5.174c-.158.392.026.653.475.653h5.089a.6.6,0,0,0,.659-.47l1.5-4.521c1.556.131,3.138.209,4.72.209s3.164-.078,4.72-.209l1.477,4.521a.622.622,0,0,0,.659.47h5.089c.422,0,.633-.261.475-.653l-1.9-5.174c.5-.1,1-.209,1.5-.34a.568.568,0,0,0,.448-.575v-3.946Z",
    transform: "translate(-21509.59 -4325.911)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdeskIconSmall);
export default __webpack_public_path__ + "static/media/airdesk_icon_small.044de999289332bab0d89e9f4b9fdfdc.svg";
export { ForwardRef as ReactComponent };